module.exports = __webpack_public_path__ + "static/rollover_ropa-2f7356df046d93626f824c971ff65ee4.svg";